
export const whitekeys= 
    [
      
    {id: 28, name: '.C', keyCode: '1', type: 'white'},
    {id: 30, name: '.D', keyCode: '2', type: 'white'},
    {id: 32, name: '.E', keyCode: '3', type: 'white'},
    {id: 33, name: '.F', keyCode: '4', type: 'white'},
    {id: 35, name: '.G', keyCode: '5', type: 'white'},
    {id: 37, name: '.A', keyCode: '6', type: 'white'},
    {id: 39, name: '.B', keyCode: '7', type: 'white'},
    {id: 40, name: 'C', keyCode: '8', type: 'white'},
    {id: 42, name: 'D', keyCode: '9',  type: 'white'},
    {id: 44, name: 'E', keyCode: '10', type: 'white'},
    {id: 45, name: 'F', keyCode: '11', type: 'white'},
    {id: 47, name: 'G', keyCode: '12', type: 'white'},
    {id: 49, name: 'A', keyCode: '13', type: 'white'},
    {id: 51, name: 'B', keyCode: '14', type: 'white'},
    {id: 52, name: 'C`', keyCode: '15', type: 'white'},
    {id: 54, name: 'D`', keyCode: '16', type: 'white'},
    {id: 56, name: 'E`', keyCode: '17', type: 'white'},
    {id: 57, name: 'F`', keyCode: '18', type: 'white'},
    {id: 59, name: 'G`', keyCode: '19', type: 'white'},
    {id: 61, name: 'A`', keyCode: '20', type: 'white'},
    {id: 63, name: 'B`', keyCode: '21', type: 'white'},
    ]
  export const blackkeys1=[
    {id: 29, name: '.#C', keyCode: 'b49', type: 'black'},
    {id: 31, name: '.#D', keyCode: 'b50', type: 'black'},
    {id: 34, name: '.#F', keyCode: 'b52', type: 'black'},
    {id: 36, name: '.#G', keyCode: 'b53', type: 'black'},
    {id: 38, name: '.#A', keyCode: 'b54', type: 'black'},
    
    
  ]
  export const blackkeys2=[
  {id: 41, name: '#C', keyCode: 'b56', type: 'black'},
  {id: 43, name: '#D', keyCode: 'b57', type: 'black'},
  {id: 46, name: '#F', keyCode: 'b81', type: 'black'},
  {id: 48, name: '#G', keyCode: 'b87', type: 'black'},
  {id: 50, name: '#A', keyCode: 'b69', type: 'black'},]
  
  export const blackkeys3=[
    {id: 53, name: '#C`', keyCode: 'b84', type: 'black'},
    {id: 55, name: '#D`', keyCode: 'b89', type: 'black'},
    {id: 58, name: '#F`', keyCode: 'b73', type: 'black'},
    {id: 60, name: '#G`', keyCode: 'b79', type: 'black'},
    {id: 62, name: '#A`', keyCode: 'b80',  type: 'black'},]


// WEBPACK FOOTER //
// ./src/util/notes.js